import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3993181f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "starry-background" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stars, (star) => {
      return (_openBlock(), _createElementBlock("div", {
        key: star.id,
        class: "star",
        style: _normalizeStyle({
        left: star.left + '%',
        top: star.top + '%',
        animationDelay: star.delay + 's',
        animationDuration: star.duration + 's'
      })
      }, null, 4))
    }), 128))
  ]))
}